import * as generalHelper from "../../../helpers/generalHelper";
import * as menuConstants from "../../../constants/menuConstants";
import * as methods from "../../../constants/serverMethods";
import * as optionHelper from "../../../helpers/optionHelper";
import * as optionsConstants from "../../../constants/optionsConstants";
import * as priceConstants from "../../../constants/entityConstants/priceConstants";
import * as propertyConstants from "../../../constants/propertyConstants";
import * as tableHelper from "../../../helpers/tableHelper";

import { AppState } from "../../../reducers";
import { BaseInProduct } from "../../../types/baseInProduct";
import { BaseInProductPackage } from "../../../types/baseInProductPackage";
import { Currency } from "../../../types/currency";
import { FileCategory } from "../../../types/fileCategory";
import { MenuItem } from "../../../types/menu";
import { PriceOption } from "../../../types/priceOption";
import { Product } from "../../../types/product";
import { ServerRequest } from "../../../types/serverRequest";
import { ZoneProductScene } from "../../../components/scenes/zone/ZoneProductScene";

import { connect } from "react-redux";

export type PropsType = Readonly<{
    menuScene: MenuItem | null;
    priceDataPrivileges: MenuItem | null;
    currency: Currency | null;
    fileCategoryList: Array<FileCategory>;
    productTableConstant: string;
    productList: Array<Product>;
    productActiveList: Array<Product>;
    productLoading: boolean;
    productButtonLoading: boolean;
    productAvailableCount: number | null;
    productColumnOrder: Array<propertyConstants.Property>;
    productColumnVisibility: Record<propertyConstants.Property, boolean>;
    productColumnWidth: Record<propertyConstants.Property, number>;
    productSceneTableSize: Record<string, any> | null;
    productOffset: number;
    productPage: number;
    productRowCount: number;
    productRowCountCustom: boolean;
    productSearch: string | null;
    productSearchParams: Record<propertyConstants.Property, string>;
    productShowFilterRow: boolean;
    productShowGlobalSearch: boolean;
    productSortingAsc: boolean;
    productSortingCriterion: propertyConstants.Property | null;
    productTotalCount: number | null;
    baseInProductTableConstant: string;
    baseInProductList: Array<BaseInProduct>;
    baseInProductActiveList: Array<BaseInProduct>;
    baseInProductLoading: boolean;
    baseInProductButtonLoading: boolean;
    baseInProductAvailableCount: number | null;
    baseInProductColumnOrder: Array<propertyConstants.Property>;
    baseInProductColumnVisibility: Record<propertyConstants.Property, boolean>;
    baseInProductColumnWidth: Record<propertyConstants.Property, number>;
    baseInProductOffset: number;
    baseInProductPage: number;
    baseInProductRowCount: number;
    baseInProductRowCountCustom: boolean;
    baseInProductSearch: string | null;
    baseInProductSearchParams: Record<propertyConstants.Property, string>;
    baseInProductShowFilterRow: boolean;
    baseInProductShowGlobalSearch: boolean;
    baseInProductSortingAsc: boolean;
    baseInProductSortingCriterion: propertyConstants.Property | null;
    baseInProductTotalCount: number | null;
    baseInProductPackageTableConstant: string;
    baseInProductPackageList: Array<BaseInProductPackage>;
    baseInProductPackageActiveList: Array<BaseInProductPackage>;
    baseInProductPackageLoading: boolean;
    baseInProductPackageButtonLoading: boolean;
    baseInProductPackageAvailableCount: number | null;
    baseInProductPackageColumnOrder: Array<propertyConstants.Property>;
    baseInProductPackageColumnVisibility: Record<propertyConstants.Property, boolean>;
    baseInProductPackageColumnWidth: Record<propertyConstants.Property, number>;
    baseInProductPackageOffset: number;
    baseInProductPackagePage: number;
    baseInProductPackageRowCount: number;
    baseInProductPackageRowCountCustom: boolean;
    baseInProductPackageSearch: string | null;
    baseInProductPackageSearchParams: Record<propertyConstants.Property, string>;
    baseInProductPackageShowFilterRow: boolean;
    baseInProductPackageShowGlobalSearch: boolean;
    baseInProductPackageSortingAsc: boolean;
    baseInProductPackageSortingCriterion: propertyConstants.Property | null;
    baseInProductPackageTotalCount: number | null;
    optionPriceDefinition: PriceOption | null;
    optionPriceEnableCompanyCost: PriceOption | null;
    optionPriceEnablePriceGroups: PriceOption | null;
    optionUseLargoNames: boolean | null;
    optionUseTmcNames: boolean | null;
    sceneLayout: string | null;
}>;

const mapStateToProps = (state: AppState): PropsType => ({
    menuScene: generalHelper.getMenuItemByKey(
        state.navigation.menuList,
        menuConstants.MENU_MAIN_PAGE,
        menuConstants.PAGE_ZONE_PRODUCTS
    ),
    priceDataPrivileges: generalHelper.getMenuItemByKey(
        state.navigation.menuList,
        menuConstants.MENU_MAIN_PAGE,
        menuConstants.PAGE_ZONE_PRICES
    ),
    currency: state.currency.zoneCurrency,
    fileCategoryList: state.fileCategory.list,
    productTableConstant: menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS,
    productList: state.product.zoneList,
    productActiveList: state.product.zoneActiveList,
    productLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ALL_ZONE_PRODUCTS ||
            request.method === methods.METHOD_GET_ZONE_PRICE_OPTIONS ||
            request.method === methods.METHOD_DELETE_ZONE_PRODUCT
    ),
    productButtonLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ZONE_PRODUCT_BY_ID ||
            request.method === methods.METHOD_EDIT_ZONE_PRODUCT
    ),
    productAvailableCount: state.product.zoneCountAvailable,
    productColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
    ),
    productColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
    ),
    productColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
    ),
    productSceneTableSize: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_TABLE_SIZE,
        menuConstants.PAGE_ZONE_PRODUCTS
    ),
    productOffset: state.product.zoneOffset,
    productPage: state.product.zonePage,
    productRowCount: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT,
        menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
    ),
    productRowCountCustom: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT_CUSTOM,
        menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
    ),
    productSearch: state.product.zoneSearch,
    productSearchParams: state.product.zoneSearchParams,
    productShowFilterRow: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_FILTER_ROW,
        menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
    ),
    productShowGlobalSearch: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_GLOBAL_SEARCH,
        menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
    ),
    productSortingAsc: tableHelper.getSortingObjectValue(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
        )
    ),
    productSortingCriterion: tableHelper.getSortingObjectKey(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_PRODUCTS_PRODUCTS
        )
    ),
    productTotalCount: state.product.zoneCountTotal,
    baseInProductTableConstant: menuConstants.TABLE_ZONE_PRODUCTS_BASES,
    baseInProductList: state.baseInProduct.zoneList,
    baseInProductActiveList: state.baseInProduct.zoneActiveList,
    baseInProductLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ALL_ZONE_PRODUCTS ||
            request.method === methods.METHOD_GET_ALL_ZONE_BASES_IN_PRODUCTS_BY_PRODUCT ||
            request.method === methods.METHOD_GET_ZONE_PRICE_OPTIONS ||
            request.method === methods.METHOD_DELETE_ZONE_BASE_IN_PRODUCT
    ),
    baseInProductButtonLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ZONE_BASE_IN_PRODUCT_BY_ID ||
            request.method === methods.METHOD_EDIT_ZONE_BASE_IN_PRODUCT
    ),
    baseInProductAvailableCount: state.baseInProduct.zoneCountAvailable,
    baseInProductColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_ZONE_PRODUCTS_BASES
    ),
    baseInProductColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_ZONE_PRODUCTS_BASES
    ),
    baseInProductColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_ZONE_PRODUCTS_BASES
    ),
    baseInProductOffset: state.baseInProduct.zoneOffset,
    baseInProductPage: state.baseInProduct.zonePage,
    baseInProductRowCount: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT,
        menuConstants.TABLE_ZONE_PRODUCTS_BASES
    ),
    baseInProductRowCountCustom: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT_CUSTOM,
        menuConstants.TABLE_ZONE_PRODUCTS_BASES
    ),
    baseInProductSearch: state.baseInProduct.zoneSearch,
    baseInProductSearchParams: state.baseInProduct.zoneSearchParams,
    baseInProductShowFilterRow: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_FILTER_ROW,
        menuConstants.TABLE_ZONE_PRODUCTS_BASES
    ),
    baseInProductShowGlobalSearch: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_GLOBAL_SEARCH,
        menuConstants.TABLE_ZONE_PRODUCTS_BASES
    ),
    baseInProductSortingAsc: tableHelper.getSortingObjectValue(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_PRODUCTS_BASES
        )
    ),
    baseInProductSortingCriterion: tableHelper.getSortingObjectKey(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_PRODUCTS_BASES
        )
    ),
    baseInProductTotalCount: state.baseInProduct.zoneCountTotal,
    baseInProductPackageTableConstant: menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES,
    baseInProductPackageList: state.baseInProductPackage.zoneList,
    baseInProductPackageActiveList: state.baseInProductPackage.zoneActiveList,
    baseInProductPackageLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ALL_ZONE_PRODUCTS ||
            request.method === methods.METHOD_GET_ALL_ZONE_BASES_IN_PRODUCTS_BY_PRODUCT ||
            request.method === methods.METHOD_GET_ALL_ZONE_BASE_IN_PRODUCT_PACKAGES_BY_BASE_IN_PRODUCT ||
            request.method === methods.METHOD_GET_ZONE_PRICE_OPTIONS ||
            request.method === methods.METHOD_DELETE_ZONE_BASE_IN_PRODUCT_PACKAGE
    ),
    baseInProductPackageButtonLoading: state.server.requests.some(
        (request: ServerRequest) =>
            request.method === methods.METHOD_GET_ZONE_BASE_IN_PRODUCT_PACKAGE_BY_ID ||
            request.method === methods.METHOD_EDIT_ZONE_BASE_IN_PRODUCT_PACKAGE
    ),
    baseInProductPackageAvailableCount: state.baseInProductPackage.zoneCountAvailable,
    baseInProductPackageColumnOrder: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_ORDER,
        menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
    ),
    baseInProductPackageColumnVisibility: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_VISIBILITY,
        menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
    ),
    baseInProductPackageColumnWidth: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_COLUMNS_WIDTH,
        menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
    ),
    baseInProductPackageOffset: state.baseInProductPackage.zoneOffset,
    baseInProductPackagePage: state.baseInProductPackage.zonePage,
    baseInProductPackageRowCount: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT,
        menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
    ),
    baseInProductPackageRowCountCustom: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_TABLE_ROW_COUNT_CUSTOM,
        menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
    ),
    baseInProductPackageSearch: state.baseInProductPackage.zoneSearch,
    baseInProductPackageSearchParams: state.baseInProductPackage.zoneSearchParams,
    baseInProductPackageShowFilterRow: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_FILTER_ROW,
        menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
    ),
    baseInProductPackageShowGlobalSearch: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SHOW_GLOBAL_SEARCH,
        menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
    ),
    baseInProductPackageSortingAsc: tableHelper.getSortingObjectValue(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
        )
    ),
    baseInProductPackageSortingCriterion: tableHelper.getSortingObjectKey(
        generalHelper.getObjectFromDictionaryByKey(
            state.login.options,
            optionsConstants.OPTION_TABLE_SORTING,
            menuConstants.TABLE_ZONE_PRODUCTS_BASE_PACKAGES
        )
    ),
    baseInProductPackageTotalCount: state.baseInProductPackage.zoneCountTotal,
    optionPriceDefinition: generalHelper.getObjectByKey(
        state.price.zoneOptionList,
        priceConstants.PRICE_OPTION_PRICE_DEFINITION
    ),
    optionPriceEnableCompanyCost: generalHelper.getObjectByKey(
        state.price.zoneOptionList,
        priceConstants.PRICE_OPTION_ENABLE_COMPANY_COST
    ),
    optionPriceEnablePriceGroups: generalHelper.getObjectByKey(
        state.price.zoneOptionList,
        priceConstants.PRICE_OPTION_ENABLE_PRICE_GROUPS
    ),
    optionUseLargoNames: optionHelper.getValueFromOptionDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_USE_LARGO_NAMES
    ),
    optionUseTmcNames: optionHelper.getValueFromOptionDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_USE_TMC_NAMES
    ),
    sceneLayout: generalHelper.getObjectFromDictionaryByKey(
        state.login.options,
        optionsConstants.OPTION_SCENE_LAYOUT,
        menuConstants.PAGE_ZONE_PRODUCTS
    )
});

export const ZoneProductSceneContainer = connect(mapStateToProps)(ZoneProductScene);
